import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import type { FilterRequest } from '~/shared/data-contract/filter';
import type { PaginatedUsers } from '~/shared/data-contract/user';
import { userPaginationSchema } from '~/shared/data-contract/user';

const pathname = '/users/filter';

export const useUsersFilterQuery = (
    { filter, paged = { page: 0, size: 20 }, sorted }: FilterRequest,
    enabled: boolean,
): UseQueryResult<PaginatedUsers> => {
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);

    return useQuery({
        enabled,
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.postJson(userPaginationSchema, {
                pathname,
                payload: {
                    filter,
                    paged,
                    sorted,
                },
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },

        queryKey: [pathname, 'postJson', filter, paged, sorted],
    });
};
